import BaseCommand from "@/models/api/commands/BaseCommand";

export class IssueDateChangeCommand extends BaseCommand {
  CommandName = "IssueDateChange";
  Command: string;
  constructor(sessionId: string, operationId: string, issueDate: string) {
    super(sessionId, operationId);
    this.Command = issueDate;
  }
}
